import {useTranslation} from 'react-i18next';

import {Box, Button, Typography, useTheme} from '@mui/material';

import {EmpionPaper} from '../../../../../components/EmpionPaper/EmpionPaper';
import {greenColors} from '../../../../../layouts/theme/designSystem';
import {WorkforceDashboardDepartmentHealth} from '../../types/workforceDashboardTypes';

export interface Props {
  departments: WorkforceDashboardDepartmentHealth[];
  selectedId: string | null;
  onSelect: (id: string | null) => void;
}

export const DepartmentSelectorBar = ({departments, selectedId, onSelect}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'workforceDepartmentHealthPage.selector'});
  const theme = useTheme();

  const handleClick = (id: string) => {
    onSelect(selectedId === id ? null : id);
  };

  return (
    <EmpionPaper
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: theme.zIndex.appBar - 1,
        bgcolor: 'background.paper',
        border: '0.5px solid',
        borderColor: 'divider',
        borderRadius: '12px',
        px: 2.5,
        py: 2.25,
        mb: 1,
      }}
    >
      <Typography
        sx={{
          fontSize: '11px',
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.6px',
          color: 'text.secondary',
          mb: 1.25,
        }}
      >
        {t('label')}
      </Typography>

      <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1}}>
        {departments.map((dept) => {
          const isActive = selectedId === dept.companyDepartmentId;

          return (
            <Button
              key={dept.companyDepartmentId}
              onClick={() => handleClick(dept.companyDepartmentId)}
              sx={{
                textTransform: 'none',
                fontSize: '13px',
                fontWeight: 500,
                borderRadius: '8px',
                px: 1.75,
                py: 0.875,
                minWidth: 0,
                border: '0.5px solid',
                borderColor: isActive ? 'transparent' : 'divider',
                bgcolor: isActive ? greenColors[500] : 'background.paper',
                color: isActive ? 'common.white' : 'text.primary',
                boxShadow: 'none',
                '&:hover': {
                  bgcolor: isActive ? greenColors[600] : 'action.hover',
                  borderColor: isActive ? 'transparent' : 'divider',
                  boxShadow: 'none',
                },
              }}
            >
              {dept.companyDepartmentName}
              <Box
                component='span'
                sx={{
                  ml: 0.5,
                  fontSize: '11px',
                  opacity: 0.6,
                }}
              >
                {dept.profileCount}
              </Box>
            </Button>
          );
        })}
      </Box>
    </EmpionPaper>
  );
};
